import { computed } from '@angular/core';
import { patchState, signalStoreFeature, withMethods, withState } from '@ngrx/signals';

export type LoadingState = 'init' | 'loading' | 'loaded' | 'error';

export function withLoadingState<T extends NonNullable<Record<string, LoadingState>>>(loading: T) {
	return signalStoreFeature(
		withState({ loading }),
		withMethods((state) => ({
			init: (key: keyof T) => {
				patchState(state, { loading: { ...state.loading(), [key]: 'init' } });
			},
			loading: (key: keyof T) => {
				patchState(state, { loading: { ...state.loading(), [key]: 'loading' } });
			},
			loaded: (key: keyof T) => {
				patchState(state, { loading: { ...state.loading(), [key]: 'loaded' } });
			},
			errored: (key: keyof T) => {
				patchState(state, { loading: { ...state.loading(), [key]: 'error' } });
			},
			isInitial: (key: keyof T) => computed(() => state.loading()[key] === 'init'),
			isLoading: (key: keyof T) => computed(() => state.loading()[key] === 'loading'),
			isLoaded: (key: keyof T) => computed(() => state.loading()[key] === 'loaded'),
			hasError: (key: keyof T) => computed(() => state.loading()[key] === 'error'),
		})),
	);
}
